import DropDownIcon from "@/ui/Icons/DropDownIcon";
import { useState } from "react";

export default function Accordion({
  title,
  discription,
}: {
  title: string;
  discription: string;
}) {
  const [isShown, setShow] = useState(false);
  return (
    <>
      <div
        className="p-3 bg-white rounded-xl border-[0.5px] border-[#E4E2E3] cursor-pointer"
        onClick={() => setShow(!isShown)}
      >
        <div className="flex items-center justify-between">
          <p className="font-semibold">{title}</p>
          <div className={`${isShown ? "transform rotate-180" : ""}`}>
            <DropDownIcon />
          </div>
        </div>
        {isShown && (
          <div className="mt-1 pt-1 border-t">
            <p className="whitespace-pre-line">{discription}</p>
          </div>
        )}
      </div>
    </>
  );
}
